/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrizeDistributionPayoutResult } from './PrizeDistributionPayoutResult';
import {
    PrizeDistributionPayoutResultFromJSON,
    PrizeDistributionPayoutResultFromJSONTyped,
    PrizeDistributionPayoutResultToJSON,
    PrizeDistributionPayoutResultToJSONTyped,
} from './PrizeDistributionPayoutResult';
import type { PrizeDistributionTournamentSummary } from './PrizeDistributionTournamentSummary';
import {
    PrizeDistributionTournamentSummaryFromJSON,
    PrizeDistributionTournamentSummaryFromJSONTyped,
    PrizeDistributionTournamentSummaryToJSON,
    PrizeDistributionTournamentSummaryToJSONTyped,
} from './PrizeDistributionTournamentSummary';

/**
 * 
 * @export
 * @interface PrizeDistributionResponse
 */
export interface PrizeDistributionResponse {
    /**
     * 
     * @type {PrizeDistributionTournamentSummary}
     * @memberof PrizeDistributionResponse
     */
    tournament: PrizeDistributionTournamentSummary;
    /**
     * 
     * @type {number}
     * @memberof PrizeDistributionResponse
     */
    totalDistributed: number;
    /**
     * 
     * @type {Array<PrizeDistributionPayoutResult>}
     * @memberof PrizeDistributionResponse
     */
    payouts: Array<PrizeDistributionPayoutResult>;
    /**
     * 
     * @type {boolean}
     * @memberof PrizeDistributionResponse
     */
    dryRun: boolean;
}

/**
 * Check if a given object implements the PrizeDistributionResponse interface.
 */
export function instanceOfPrizeDistributionResponse(value: object): value is PrizeDistributionResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('totalDistributed' in value) || value['totalDistributed'] === undefined) return false;
    if (!('payouts' in value) || value['payouts'] === undefined) return false;
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    return true;
}

export function PrizeDistributionResponseFromJSON(json: any): PrizeDistributionResponse {
    return PrizeDistributionResponseFromJSONTyped(json, false);
}

export function PrizeDistributionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeDistributionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': PrizeDistributionTournamentSummaryFromJSON(json['tournament']),
        'totalDistributed': json['totalDistributed'],
        'payouts': ((json['payouts'] as Array<any>).map(PrizeDistributionPayoutResultFromJSON)),
        'dryRun': json['dryRun'],
    };
}

export function PrizeDistributionResponseToJSON(json: any): PrizeDistributionResponse {
    return PrizeDistributionResponseToJSONTyped(json, false);
}

export function PrizeDistributionResponseToJSONTyped(value?: PrizeDistributionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': PrizeDistributionTournamentSummaryToJSON(value['tournament']),
        'totalDistributed': value['totalDistributed'],
        'payouts': ((value['payouts'] as Array<any>).map(PrizeDistributionPayoutResultToJSON)),
        'dryRun': value['dryRun'],
    };
}

